angular
    .module('BBPublicBooking')
    .factory('Purchase.CourseBookingModel', ($q, BBModel, BaseModel) =>

    class Purchase_Course_Booking extends BaseModel {
        constructor(data) {
            super(data);
        }

        getBookings() {
            const defer = $q.defer();
            if (this.bookings) {
                defer.resolve(this.bookings);
            }
            if (this._data.$has('bookings')) {
                this._data.$get('bookings').then((bookings) => {
                        this.bookings = ((() => {
                            const result = [];
                            for (const b of Array.from(bookings)) {
                                result.push(new BBModel.Purchase.Booking(b));
                            }
                            return result;
                        })());
                        this.bookings.sort((a, b) => a.datetime.unix() - b.datetime.unix());
                        defer.resolve(this.bookings);
                    }
                );
            } else {
                this.bookings = [];
                defer.resolve(this.bookings);
            }
            return defer.promise;
        }
    }
);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/purchase/_models/purchase_course_booking_model.service.js